import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/ReportTypes'

export const clearDownloadReportURL = createAction(types.CLEAR_DOWNLOAD_REPORT_URL)
export const clearReportExpenses = createAction(types.CLEAR_REPORT_EXPENSES)
export const createReport = createAction(types.CREATE_REPORT)
export const createReportFailed = createAction(types.CREATE_REPORT_FAILED)
export const createReportSucceeded = createAction(types.CREATE_REPORT_SUCCEEDED)
export const deleteReport = createAction(types.DELETE_REPORT)
export const deleteReportFailed = createAction(types.DELETE_REPORT_FAILED)
export const deleteReportSucceeded = createAction(types.DELETE_REPORT_SUCCEEDED)
export const fetchAuditLogs = createAction(types.FETCH_AUDIT_LOGS)
export const fetchAuditLogsFailed = createAction(types.FETCH_AUDIT_LOGS_FAILED)
export const fetchAuditLogsSucceeded = createAction(types.FETCH_AUDIT_LOGS_SUCCEEDED)
export const fetchReportExpenses = createAction(types.FETCH_REPORT_EXPENSES)
export const fetchReportExpensesFailed = createAction(types.FETCH_REPORT_EXPENSES_FAILED)
export const fetchReportExpensesSucceeded = createAction(types.FETCH_REPORT_EXPENSES_SUCCEEDED)
export const fetchReports = createAction(types.FETCH_REPORTS)
export const fetchReportsFailed = createAction(types.FETCH_REPORTS_FAILED)
export const fetchReportsSucceeded = createAction(types.FETCH_REPORTS_SUCCEEDED)
export const updateReport = createAction(types.UPDATE_REPORT)
export const updateReportFailed = createAction(types.UPDATE_REPORT_FAILED)
export const updateReportSucceeded = createAction(types.UPDATE_REPORT_SUCCEEDED)
export const createExportReport = createAction(types.CREATE_EXPORT_REPORT)
export const createExportReportFailed = createAction(types.CREATE_EXPORT_REPORT_FAILED)
export const createExportReportSucceeded = createAction(types.CREATE_EXPORT_REPORT_SUCCEEDED)
export const createTransactionReport = createAction(types.CREATE_TRANSACTION_REPORT)
export const createTransactionReportFailed = createAction(types.CREATE_TRANSACTION_REPORT_FAILED)
export const createTransactionReportSucceeded = createAction(
  types.CREATE_TRANSACTION_REPORT_SUCCEEDED,
)
